import { render } from "./admin-img-list.vue?vue&type=template&id=2091d8da"
import script from "./admin-img-list.vue?vue&type=script&lang=js"
export * from "./admin-img-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__